:host {
  display: block;
}

::slotted(*), div {
  pointer-events: none;
}

a,
button {
  padding: $size-space-xs $size-space-sm;
  display: flex;
  flex: 1;
  width: 100%;
  border-radius: 200px;
  font-weight: 900;
  font-size: $size-typography-bodytext-1;
  line-height: $size-line-height-bodytext-1;
  font-family: $font-family-primary;
  align-items: center;
  text-align: center;
  justify-content: center;
  appearance: none;
  border-style: solid;
  cursor: pointer;
}
a {
  text-decoration: none;
}
button {
  height: 40px;
}

.link {
  display: flex;
  align-items: center;

  .text {
    display: flex;
    justify-content: center;
    text-align: center;
    flex-grow: 1;
  }
  &--left {
    justify-content: flex-start;
  }
  &--right {
    flex-direction: row-reverse;
    justify-content: flex-start;
  }
}

.primary {
  background-color: $color-base-brand-yellow;
  border-color: $color-base-brand-yellow;
  color: $color-typography-typo-88;

  &:hover {
    background-color: $color-base-brand-yellow-dark;
    border-color: $color-base-brand-yellow-dark;
  }

  &:disabled {
    background-color: $color-base-gray-gray-2;
    border-color: $color-base-gray-gray-2;
    color: $color-typography-typo-48;
  }
}

.secondary {
  background-color: $color-base-brand-white;
  border-width: 1px;
  border-color: $color-base-brand-yellow;
  color: $color-typography-typo-88;

  &:hover {
    background-color: $color-action-alert-pastel;
    border-color: $color-base-brand-yellow;
  }

  &:disabled {
    background-color: $color-base-brand-white;
    border-width: 1px;
    border-color: $color-base-gray-gray-2;
    color: $color-typography-typo-48;
  }
}

.red {
  background-color: $color-action-destrutive;
  border-color: $color-action-destrutive;
  color: $color-typography-typo-fff;

  &:hover {
    background-color: $color-action-destrutive-dark;
    border-color: $color-action-destrutive-dark;
  }
}

div {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  flex: 1;
}

.left {
  flex-direction: row;
}

.right {
  flex-direction: row-reverse;
}
